import A from 'components/atoms/A/A';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import classes from './LoginForm.module.scss';
import LoginFormBaseWrapper, { LoginFormConfig } from './LoginFormBase';

export type Props = {};

export default function LoginForm({}: Props) {
  const config: LoginFormConfig = {
    title: 'Welcome back',
    introText: 'Sign in, share your opinions and start earning.',
    submitButtonText: 'Sign in',
    verifyButtonText: 'Verify',
    forgotPassword: {
      href: '/forgot-password',
      text: 'Forgot password',
    },
    footer: (
      <Txt className={classes.alternativeCta}>
        New to Mobiworkx?{' '}
        <A href="/" className={classes.ctaLink}>
          Create account
        </A>
      </Txt>
    ),
  };

  return <LoginFormBaseWrapper config={config} />;
}
